export default __webpack_public_path__ + "static/media/steps.3fefc087.svg";